










































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import UUIFComponents from '@/shared/uuifComponent';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwToggle } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle';

const cssPrefix = 'product-dropdown';

@Component({
  components: {
    ...UUIFComponents,
    SwIcon,
    SwToggle,
  },
})

export default class ProductDropdown extends SwExtendedVue {
  cssPrefix = cssPrefix;
  dropdownOpen: boolean = false;
  showMyProductsToggle: boolean = false;
  @Prop()
  dropdownItems : any;
  @Prop({ type:Boolean })
  showSimpleDropdown : Boolean;
  @Prop({ type:String })
  placeholderText : String;
  @Prop({ type:String })
  preSelected : String;
  @Watch('preSelected')
  preTextChanged() {
    if (this.preSelected === '' && !this.preSelected) {
      this.selectedOption = this.placeholderText;
    }
  }
  selectedOption: any = '';

  searchedItem: any = '';
  combinedProducts: any = [];
  searchProducts: any = [
    {
      heading: 'MY PRODUCTS',
      products: [],
    },
    {
      heading: 'OTHER PRODUCTS',
      products: [],
    },
  ];

  get localDropdownItems() {
    if (!this.showSimpleDropdown) {
      const myProduct: any = [];
      const otherProduct: any = [];
      if (this.searchedItem !== '') {
        let combinedProducts = [];
        if (!this.showMyProductsToggle) {
          combinedProducts = [...this.dropdownItems[0].products, ...this.dropdownItems[1].products];
        } else {
          combinedProducts = [...this.dropdownItems[0].products];
        }
        const filtered = combinedProducts.filter((ele: any) => {
          return ele.label.toLowerCase()
          .includes(this.searchedItem.toLowerCase());
        });
        filtered.forEach((el: any) => {
          if (el.isMyProduct === 1) {
            myProduct.push(el);
          } else {
            otherProduct.push(el);
          }
        });
        if (!this.showMyProductsToggle) {
          this.searchProducts[0].products = myProduct;
          this.searchProducts[1].products = otherProduct;
        } else {
          this.searchProducts[0].products = myProduct;
        }
        if (this.showMyProductsToggle) {
          return this.searchProducts.splice(1, 1);
        }
        return this.searchProducts;
      }
    } else if (this.showSimpleDropdown) {
      if (this.searchedItem) {
        const filtered = this.dropdownItems[0].products.filter((ele: any) => ele.label.toLowerCase()
      .includes(this.searchedItem.toLowerCase()));
        return [{ heading: '', products: filtered }];
      }
    }
    if (this.showMyProductsToggle) {
      return [{
        heading: 'MY PRODUCTS',
        products: this.dropdownItems[0].products,
      }];
    }
    if (!this.showMyProductsToggle) {
      return this.dropdownItems;
    }
    return this.dropdownItems;
  }

  handleShowToggle() {
    console.warn(this.showMyProductsToggle);
  }

  linkClicked(val: any) {
    this.selectedOption = val.label;
    this.dropdownOpen = !this.dropdownOpen;
    if (!this.showSimpleDropdown) {
      this.$emit('selectedValue', val.familyName);
    } else {
      this.$emit('selectedValue', this.selectedOption);
    }
  }

  created() {
    // @ts-ignore
    window.addEventListener('click', (e: any) => {
      // @ts-ignore
      if (!e.target.className.includes('product-dropdown') && !e.target.className.includes('icon-arrow-up')) {
        this.dropdownOpen = false;
      }
    });
    if (this.preSelected) {
      if (this.preSelected.length > 0) {
        this.selectedOption = this.preSelected;
      } else {
        this.selectedOption = this.placeholderText;
      }
    } else {
      this.selectedOption = this.placeholderText;
    }
  }
}
